<script>
    import {flip} from 'svelte/animate';

    import * as Utils from '@js/modules/utils';
    import I18n from '@js/modules/translations';

    import {searchStore} from '@js/stores/searchStore';
    import {mapStore} from '@js/stores/mapStore';

    import RideMiniCard from '@js/components/ride/RideMiniCard.svelte';

    const _handleRideHover = (rideId, isHover) => {
        if (window.innerWidth < window.settings.medium_screen) {
            return;
        }

        searchStore.highlightedRideId = isHover ? rideId : undefined;

        if (!mapStore.map) {
            return;
        }

        mapStore.map.highlightRide(searchStore.highlightedRideId, {
            openPopup: true,
            showTrack: true
        });
    };
</script>

{#if searchStore.isSearching && !$searchStore.ridesData.length}
    <div role="status" class="max-w-sm mt-5 animate-pulse">
        <div class="h-20 mb-2.5 bg-gray-200 rounded-lg"></div>
        <div class="h-20 mb-2.5 bg-gray-200 rounded-lg"></div>
        <div class="h-20 mb-2.5 bg-gray-200 rounded-lg"></div>
        <span class="sr-only">Loading...</span>
    </div>
{:else if !$searchStore.ridesData.length}
    <div class="my-8 mx-auto text-base text-center">
        {#if Utils.isPresent(searchStore.query)}
            {
                searchStore.hasFilters
                    ?
                    I18n.t('js.search.index.no_results.title_filters')
                    :
                    I18n.t('js.search.index.no_results.title')
            }

            <span class="font-bold">
                {searchStore.query}
            </span>
        {/if}
    </div>
{/if}

<ul class="md:h-[63vh] md:my-4 md:px-2 overflow-y-auto">
    {#each $searchStore.ridesData
        .slice()
        .sort((rideA, rideB) => rideA.score < rideB.score)
        .sort((ride) => ($searchStore.visibleRideIds.includes(ride.id) ? -1 : 1)) as ride (ride.id)}
        <li animate:flip={{ duration: 500 }}
            onmouseenter={_handleRideHover.bind(this, ride.id, true)}
            onmouseleave={_handleRideHover.bind(this, ride.id, false)}>
            <RideMiniCard ride={ride}
                          isHighlighted={$searchStore.highlightedRideId === ride.id}
                          isFaded={!$searchStore.visibleRideIds.includes(ride.id)}/>
        </li>
    {/each}
</ul>

<div class="faded-list"></div>

<style>
    .faded-list {
        position: absolute;
        bottom: 0;
        left: 0;
        height: 60px;
        width: 100%;
        background: transparent linear-gradient(hsla(0, 0%, 100%, 0), hsla(0, 0%, 100%, .85), #fff);
    }
</style>
